import { computed, makeObservable } from 'mobx'

import asyncAction from 'modules/core/lib/asyncAction'
import { Model } from 'modules/core/lib/mobx-rest'
import companies from 'modules/core/store/collections/companies'
import type Company from 'modules/core/store/models/Company'

export interface IAtsCompany {
  id: string
  company_id: string
  public_careers_page_active: boolean
  locale: string
  header_id: string
  jobs_url?: string
  linkedin_id?: string
  favicon?: string
  show_factorial_ats: boolean
  plan_job_postings_limit: number
  active_job_postings_count: number
  job_postings_count: number
  show_team_in_job_openings: boolean
  show_privacy_policy: boolean
  show_factorial_badge: boolean
  show_workplace_type_in_job_openings: boolean
  privacy_policy_recipients: string
  talent_pool_by_default: boolean
  referrals_enabled: boolean
  requisitions_enabled: boolean
  ats_trial_limit: string
  legal_notice_custom_url: string
  legal_notice_custom_url_active: boolean
  public_email: string
  privacy_policy_custom_url: string
  privacy_policy_custom_url_active: boolean
}

class AtsCompany extends Model<IAtsCompany> {
  constructor(attr: IAtsCompany) {
    super(attr)
    makeObservable(this, {
      company: computed,
    })
  }

  static urlRoot() {
    return '/ats/companies'
  }

  get company(): Company {
    const company = companies.find({
      id: this.attributes.company_id,
    })

    if (!company) {
      throw Error(`Error finding companies with id = ${this.attributes.company_id}`)
    }

    return company
  }

  get slug(): string {
    return this.company.attributes.slug
  }

  addFavicon(favicon: File) {
    return this.rpc('add_favicon', {
      favicon,
    })
  }

  async toggleJobRequisitions() {
    const hasRequisitionsEnabled = !!this.attributes.requisitions_enabled

    const result = await asyncAction(() =>
      this.rpc('toggle_job_requisitions', {
        id: this.attributes.id,
        enabled: !hasRequisitionsEnabled,
      })
    )

    if (result.success) this.set(result.value)
  }

  async removeFavicon() {
    const result = await asyncAction(() => this.rpc('remove_favicon', {}))

    if (result.success) this.set(result.value)

    return Promise.resolve(result)
  }
}

export default AtsCompany
